import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import type AiCostLimitSubjectsView from '@UI/Store/AiCostLimits/Views/AiCostLimitSubjectsView';
import type AiCostLimitUsersListView from '@UI/Store/AiCostLimits/Views/AiCostLimitUsersListView';

/** Name of what a limit bounds; a subject no longer found, or not loaded yet, reads "Périmètre supprimé". */
const resolveSubjectName = (
	level: AiCostLimitLevel,
	subjectId: number,
	subjects: AiCostLimitSubjectsView | null,
	users: AiCostLimitUsersListView | null,
): string => {
	if (level === 'account') {
		return 'Compte';
	}

	if (level === 'organization' || level === 'facility') {
		return subjects?.findName(level, subjectId) ?? 'Périmètre supprimé';
	}

	return users?.findById(subjectId)?.fullName ?? 'Périmètre supprimé';
};

export default resolveSubjectName;
